import type { FormAddress } from '@innogy/common-ui/forms';
import { createAction, props } from '@ngrx/store';

const feature = 'SolarPanels';
const PREFIX = `[${feature} Order Form]`;

export const resetSolarPanelsOrderFormAction = createAction(
  `${PREFIX} Reset form`
);

export const prefillSolarPanelsOrderFormAddressStateAction = createAction(
  `${PREFIX} Prefill address form data`,
  props<{ payload: Partial<FormAddress> }>()
);

export const addCheckboxFormControlAction = createAction(
  `${PREFIX} Add checkbox form control`,
  props<{ name: string; validator?: any }>()
);
